import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

type DetailDisplayRowProps = {
  label: string;
  value?: string;
  icon?: ReactNode;
  capitalize?: boolean;
  testId?: string;
};

const DetailDisplayRow = ({
  label,
  value,
  icon,
  capitalize = true,
  testId = "testId",
}: DetailDisplayRowProps) => (
  <Box
    data-testid={testId}
    sx={{
      py: 1,
      display: "flex",
      alignItems: "flex-start",
      gap: 3
    }}>
    <Typography
      variant="body2"
      sx={{
        fontWeight: 500,
        width: 160,
        flexShrink: 0
      }}>
      {label} {icon}
    </Typography>
    <Typography variant="body2" sx={{
      textTransform: capitalize ? 'capitalize' : 'none'
    }}>
      {value || 'None'}
    </Typography>
  </Box>
);

export default DetailDisplayRow;
